// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d231cef2","121":"48acb75b","355":"9e225913"}[chunkId] + ".chunk.js";
};